import React, { useState, useEffect } from 'react';
import HourSelector from './HourSelector';
import apiFetcher from '../../utils/apiFetcher';
import GoogleMaps from './GoogleMaps2';
import { APIProvider} from '@vis.gl/react-google-maps';
import AmountSelector from './AmmountSelector';
const AddressForm = ({ calendar }) => {
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [communes, setCommunes] = useState([]);
  const [cities, setCities] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedCommune, setSelectedCommune] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedService, setSelectedService] = useState(``);
  const [error, setError] = useState(``);
  const { availableHours,link, setFormPage,setStartHour, setEndHour,setCity,setService, setLink,setAddress,setReferralCode,address,setInProgress,amount,setAmount} = calendar;
  const [selectedStartHour, setSelectedStartHour] = useState(null); 
  const [selectedEndHour, setSelectedEndHour] = useState(null);
  const [bounds, setBounds] = React.useState(null);
  const [currentLocation, setCurrentLocation] = React.useState('');
  const [searchAddress, setSearchAddress] = useState('');
  const [searchPosition, setSearchPosition] = useState(null);






  
  const hours = Array.from({ length: 10 }, (_, i) => i + 7);

  const buildQuery = (city, commune, district, province) => {
  return `${city || commune || district}, ${province}, Polska`;
  };
  const fetchGeocodeData = async (location) => {
  if (!location) return null;

  const url = `https://koparkoladowarka-99ee7a3b3d34.herokuapp.com/api/geocode?address=${
    encodeURIComponent(location + ", Polska")
  }`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.status === "OK" && data.results.length > 0) {
      const { lat, lng } = data.results[0].geometry.location;

      return { lat, lng };
    }

    return null;
  } catch (err) {
    console.error(err);
    return null;
  }
};

  const handleSearchAddress = async () => {
    const position = await fetchGeocodeData(searchAddress);
    if (position) {
      setSearchPosition(position);
      setAddress(searchAddress);
      
    }
  };

  

  function capitalizeWords(text) {
    return text
      .split(` `)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(` `);
  }

  function removeParentheses(text) {
    return capitalizeWords(text).replace(/\(.*?\)/g, "").trim();
  }

  useEffect( () => {
    async function fetchProvinces() {
      const {provinces} = await apiFetcher.getProvinces()
      setProvinces(provinces);
    }
    setInProgress(true)
    fetchProvinces();

  },[])


  React.useEffect(() => {
    if (currentLocation) {
      fetchGeocodeData(currentLocation);
    }
  }, [currentLocation]);

const handleProvinceChange = async (e) => {
  const province = e.target.value;

  setSelectedProvince(province);
  setDistricts([]);
  setCommunes([]);
  setCities([]);
  setServices([]);
  setSelectedDistrict('');
  setSelectedCommune('');
  setSelectedCity('');
  setCurrentLocation(`Województwo ${province}`);

  try {
    const response = await apiFetcher.getDistricts(province);
    setDistricts(response.district || []);
    const query = `${province}, Polska`;

    const pos = await fetchGeocodeData(query);
    if (pos) {
      setSearchPosition({ ...pos, type: "province" });
    }

  } catch (error) {
    console.error("Error fetching districts:", error);
    setDistricts([]);
  }
};

const handleDistrictChange = async (e) => {
  const district = e.target.value;

  setSelectedDistrict(district);
  setCommunes([]);
  setCities([]);
  setServices([]);
  setSelectedCommune('');
  setSelectedCity('');
  setCurrentLocation(`Województwo ${selectedProvince} Powiat ${district}`);

  try {
    const response = await apiFetcher.getCommunes(district);
    setCommunes(response.commune || []);

    const query = buildQuery(district, null, null, selectedProvince);

    const pos = await fetchGeocodeData(query);

    if (pos) {
      setSearchPosition({ ...pos, type: "district" });
    }

  } catch (error) {
    console.error("Error fetching communes:", error);
    setCommunes([]);
  }
};

const handleCommuneChange = async (e) => {
  const commune = e.target.value;

  setSelectedCommune(commune);
  setCities([]);
  setServices([]);
  setSelectedCity('');
  setCurrentLocation(`Województwo ${selectedProvince} Powiat ${selectedDistrict} Gmina ${commune}`);

  try {
    const response = await apiFetcher.getCities(commune);
    setCities(response.city || []);

    const query = buildQuery(commune, null, selectedDistrict, selectedProvince);
    const pos = await fetchGeocodeData(query);
    if (pos) {
      setSearchPosition({ ...pos, type: "commune" });
    }

  } catch (error) {
    console.error("Error fetching cities:", error);
    setCities([]);
  }
};

const handleCityChange = async (e) => {
  const city = e.target.value;

  setCity(city);
  setSelectedCity(city);
  setServices([]);
  setCurrentLocation(`Województwo ${selectedProvince} Powiat ${selectedDistrict} Gmina ${selectedCommune} Miejscowość ${city}`);

  try {
    console.log(city)
    const response = await apiFetcher.getServices(city);
    console.log(city)
    setServices(response.service || []);

    const query = buildQuery(city, selectedCommune, selectedDistrict, selectedProvince);

    const pos = await fetchGeocodeData(query);
    if (pos) {
      setSearchPosition({ ...pos, type: "city" });
    }

  } catch (error) {
    console.error("Error fetching services:", error);
    setServices([]);
  }
};

  const handleServiceChange = (e) => {
      const service = e.target.value;
      setSelectedService(service);
      setService(service);
  }

  const handleStartHourSelect = (hour) => {
    setSelectedStartHour(hour);
    setStartHour(hour); 
    setSelectedEndHour(null)
  };

  const handleEndHourSelect = (hour) => {
    setSelectedEndHour(hour); 
    setEndHour(hour);
  };

  const isRangeValid = (start, end) => {
    if (!start || !end || start >= end) return false;
    for (let h = start; h <= end; h++) {
      if (!availableHours.includes(h)) {
        return false; 
      }
    }
    return true;
  };


  const handleSubmit = () => {
    if(selectedCity 
      && selectedService 
      && selectedStartHour 
      && selectedEndHour 
      && link) {
      if(isRangeValid(selectedStartHour,selectedEndHour)) {
        const token = localStorage.getItem(`jwt`);
        if(token) {
          setError(``);
          setFormPage(3)
        }else {
          setError(``);
          setFormPage(2)
        }
      }else {
        setError(`Wybierz poprawne godziny!`)
      }
    }else {
      setError(`Wybierz godziny, wypełnij wszystkie pola oraz ustaw pinezkę!`)
    }
  }

  // const getAvailableEndHours = () => {
  //   if (!selectedStartHour) return availableHours;
  //   const validEndHours = [];
  //   let isContinuous = true;

  //   for (let hour of availableHours) {
  //     if (hour > selectedStartHour && isContinuous) {
  //       if (availableHours.includes(hour)) {
  //         validEndHours.push(hour);
  //       } else {
  //         isContinuous = false;
  //       }
  //     }
  //   }
  //   return validEndHours;
  // };


  return (
    <div id="adress-information-container" className="adress-information-container">
            <h1>Zaproponuj godziny dostaw</h1>
      <div className="hours-container">
      <HourSelector
          start={true}
          availableHours={availableHours}
          hours={hours}
          title="Godzina początku"
          setHour={handleStartHourSelect}
          selectedHour={selectedStartHour}
        />
        <HourSelector
          availableHours={availableHours}
          hours={hours}
          title="Godzina końca"
          setHour={handleEndHourSelect}
          selectedHour={selectedEndHour}
          right={true} 
        />
        
      </div>
      <div className="adress-row-container">
          <div className="select-container">
              <div className="location-container">
                  <h3>Podaj nam kilka informacji</h3>
                  <select
              name="location"
              id="select-province"
              onChange={handleProvinceChange}
              value={selectedProvince}
            >
              <option disabled value="">Województwo</option>
              {provinces.map((province) => (
                <option key={province} value={province}>
                  {removeParentheses(province)}
                </option>
              ))}
            </select>
            <select
              name="location"
              id="select-district"
              disabled={!districts.length}
              onChange={handleDistrictChange}
              value={selectedDistrict}
            >
              <option disabled value="">Powiat</option>
              {districts.map((district) => (
                <option key={district} value={district}>
                  {removeParentheses(district)}
                </option>
              ))}
            </select>
            <select
              name="location"
              id="select-commune"
              disabled={!communes.length}
              onChange={handleCommuneChange}
              value={selectedCommune}
            >
              <option disabled value="">Gmina</option>
              {communes.map((commune) => (
                <option key={commune} value={commune}>
                  {removeParentheses(commune)}
                </option>
              ))}
            </select>
            <select
              name="location"
              id="select-city"
              disabled={!cities.length}
              onChange={handleCityChange}
              value={selectedCity}
            >
              <option disabled value="">Miejscowość</option>
              {cities.map((city) => (
                <option key={city} value={city}>
                  {removeParentheses(city)}
                </option>
              ))}
            </select>
            <select
              name="service"
              id="select-service"
              disabled={!services.length}
              onChange={(e) => {handleServiceChange(e)}}
              value={selectedService}
            >
              <option disabled value="">Wybierz usługę</option>
              {services.map((service) => (
                <option key={service} value={service}>
                  {removeParentheses(service)}
                </option>
              ))}
            </select>
                  <AmountSelector 
                    value={amount} 
                    onChange={setAmount}
                    service={selectedService} 
                  />
                  {/* <input placeholder='Adres' type='text' 
                  onChange={(e) => {setAddress(e.target.value.trim())}}>
                  </input> */}
                  {/* <input placeholder="Kod polecenia (jeśli posiadasz)" type="text" 
                  onChange={(e) => {setReferralCode(e.target.value.trim())}}>
                  </input> */}
              </div>
          </div>
          <div className='map-container'>
            <h3>Ustaw pinezkę w miejsce docelowe</h3>
            <input className='map-input'

          placeholder="Wyszukaj adres..."
          type="text"
          value={searchAddress}
          onChange={(e) => setSearchAddress(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearchAddress()}
        />
        <APIProvider apiKey="AIzaSyCaQ2IlzkIWOdUeCPIkZXY8okvYUhr4Z0M">
          <GoogleMaps bounds={bounds} setLink={setLink} searchPosition={searchPosition} />
        </APIProvider>
          </div>

      </div>
      <h3 style={{color: "red"}}>{error}</h3>
      <button onClick={() => {handleSubmit()}} id="adress-submit-button"><h3>Dalej &rarr;</h3></button>
    </div>
  );
};

export default AddressForm;